<!--项目类型列表-->
<template>
   <div>
      <!--搜索栏-->
      <div class="contribute" v-show="false">
         <div class="inner_view">
            <div class="spanClass">
               <span style="line-height: 32px">项目名称:</span>
               <el-input v-model="filter.prjName" placeholder="请输入项目名称" @clear="searchData"
                         :clearable="true" style="margin-left: 10px;width: 200px;"></el-input>
            </div>
         </div>
         <div>
            <el-button type="primary" style="margin-left: 20px" @click="searchData">
               查询
            </el-button>
         </div>
      </div>
      <!--表格数据展示-->
      <div class="contribute tableContainer">
         <el-table :data="table.data" border ref="mainTable" row-key="rowID" v-loading="table.showLoading">
            <el-table-column type="index" :index="indexNo" label="序号" width="50" fixed="left"></el-table-column>
            <div v-for="(item,index) in table.column" :key="index">
               <el-table-column :prop="item.prop" :label="item.label"></el-table-column>
            </div>
            <el-table-column fixed="right" label="操作">
               <template v-slot="scope">
                  <el-button type="text" v-if="isShowApply(scope.row)" size="small" @click="rowApply(scope.row)">
                     开始申报
                  </el-button>
                  <el-button type="text" size="small" @click="rowDetail(scope.row)">
                     查看明细
                  </el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <!--分页栏-->
      <div style="margin-top: 50px;" v-if="pager.rowCount>10">
         <el-pagination background :layout="pager.layout" :current-page="pager.pageIndex" :page-size="pager.pageSize"
                        :total="pager.rowCount" @size-change="pageSizeChange"
                        @current-change="pageIndexChange"></el-pagination>
      </div>
      <!--要展示的对话框-->
      <div class="dialog">

      </div>
   </div>
</template>

<script>
   import {getProjectList_Apply} from '@/api/modules/project.js'
   import ruiDate from "@/utils/ruiDate";

   export default {
      data() {
         return {
            filter: {
               prjName: ''
            },
            pager: {
               layout: 'total, sizes, prev, pager, next, jumper',
               pageIndex: 1,
               pageSize: 10,
               rowCount: 0,
            },
            table: {
               data: [],
               //表格列配置
               column: [{'prop': 'project_name', 'label': '项目名称'},
                  {'prop': 'apply_date', 'label': '申报时间'},
                  {'prop': 'applyCount', 'label': '已申报'}],
               showLoading: false
            },
            ddl: {
               //处理状态
               statusList: [{'text': '未提交', 'value': '0'}, {'text': '已提交', 'value': '1'}]
            }
         }
      },
      components: {},
      created() {
         this.searchData()
      },
      computed: {
         //计算行号
         indexNo() {
            return this.pager.pageSize * (this.pager.pageIndex - 1) + 1
         },
      },
      methods: {
         /*时间比较*/
         isShowApply(row) {
            if (ruiDate.compare(ruiDate.getNowTime(), row.apply_end) < 0)
               return true;
            return false;
         },
         /*开始申报*/
         async rowApply(row) {
            /*先进企业申报*/
            if (row.project_type == 14)
               this.$router.push({path: '/index/advCompanyApply/apply', query: {prjCode: row.project_code}})
            /*优秀企业家*/
            if (row.project_type == 16)
               this.$router.push({path: '/index/advEnterpriserApply/apply', query: {prjCode: row.project_code}})
         },
         /*查看明细*/
         async rowDetail(row) {
            /*先进企业申报*/
            if (row.project_type == 14)
               this.$router.push('/index/advCompanyApply/applyList')
            /*优秀企业家*/
            if (row.project_type == 16)
               this.$router.push('/index/advEnterpriserApply/applyList')
         },
         //获取项目数据
         async searchData() {
            const params = {
               ...this.filter,
               //门户类型
               portalType: localStorage.getItem('portalType'),
               //登录账号归属企业
               company_code: localStorage.getItem("company_code"),
               pageIndex: this.pager.pageIndex,
               pageSize: this.pager.pageSize
            }
            this.loading = true
            await getProjectList_Apply({
               data: params,
               success: (res) => {
                  this.table.data = res.data.list;
                  this.pager.rowCount = res.data.pageInfo.rowCount
                  this.loading = false
               }
            })
         },
         //换页切换
         pageIndexChange(val) {
            this.pager.pageIndex = val
            this.searchData()
         },
         //分页数量切换
         pageSizeChange(val) {
            this.pager.pageSize = val
            this.searchData()
         },
         //显示模态对话框
         showDialog(type, row) {
            this.$refs[type].showDialog(row);
         },
      }
   }
</script>

<style scoped="scoped">

   .tableContainer {
      width: 100%;
      min-height: 90px;
      height: auto;
      background-color: #f9f9f9;
   }

   .tableContainer thead th {
      background-color: #dce0e6 !important;
      font-weight: bold;
      font-size: 15px;
      width: calc(100% - 2px);
   }

   .contribute {
      display: flex;
      margin: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 40px;
   }

   .inner_view {
      line-height: 50px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      align-content: space-around;
      justify-content: flex-start;
   }

   .spanClass {
      line-height: 32px;
      margin-left: 20px;
   }

</style>
